// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pdf-border {\n  fill: white;\n  stroke: rgba(0, 0, 0, 0.2);\n  stroke-width: 2px; }\n\n.pdf-pager {\n  fill: rgba(64, 64, 64, 0.9); }\n\n.pdf-pager-text {\n  font-size: 1.3em;\n  fill: whitesmoke; }\n\n.pdf-header-btn {\n  cursor: pointer;\n  fill: whitesmoke; }\n\n.pdf-header-btn-txt {\n  cursor: pointer; }\n", ""]);
// Exports
module.exports = exports;
